export const TOTAL_STEPS = 3
export const BREAKPOINT_MID = "30rem"
